import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import createPersistedState from 'vuex-persistedstate'

import app from './modules/app'
import auth from './modules/auth'
import profile from './modules/profile'
import organisation from './modules/organisation'
import request from './modules/request'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'
let plugins = []
if (debug) {
    plugins.push(createLogger)
}
plugins.push(createPersistedState({
    key: process.env.passievooronderwijs,
    paths: [
        'auth.isLoggedIn',
        'auth.user',
        'profile.facets',
        'profile.profiles',
        'profile.profilesLastUpdatedAt',
        'profile.loadedProfiles',
    ]
}))

export default new Vuex.Store({
    modules: {
        app,
        auth,
        profile,
        organisation,
        request,
    },
    strict: debug,
    plugins
})
